import { User } from '../models/User';
import { AuthService } from '../services/AuthService';

export class UserProfileDisplay {
  private container: HTMLElement;
  private authService: AuthService;
  private user: User;
  
  constructor(user: User, authService: AuthService) {
    this.user = user;
    this.authService = authService;
    
    this.container = document.createElement('div');
    this.container.className = 'user-profile-display';
    this.render();
  }
  
  private render(): void {
    const isAnonymous = this.user.isAnonymous;
    
    this.container.innerHTML = `
      <div class="user-info">
        <span class="user-icon">${isAnonymous ? '🎮' : '👤'}</span>
        <span class="user-name">${this.user.displayName}</span>
        ${isAnonymous ? `
          <button id="upgrade-account" class="upgrade-button" title="Googleアカウントにアップグレード">
            アップグレード
          </button>
        ` : ''}
        <button id="logout-button" class="logout-button" title="ログアウト">
          ログアウト
        </button>
      </div>
      <div class="user-stats">
        <div class="stat-item">
          <span class="stat-label">プレイ回数:</span>
          <span class="stat-value">${this.user.stats.totalGames}</span>
        </div>
        <div class="stat-item">
          <span class="stat-label">ベストタイム:</span>
          <span class="stat-value">${this.formatTime(this.user.stats.bestTime)}</span>
        </div>
      </div>
    `;
    
    this.attachEventHandlers();
  }
  
  private attachEventHandlers(): void {
    const logoutBtn = this.container.querySelector('#logout-button');
    if (logoutBtn) {
      logoutBtn.addEventListener('click', () => this.handleLogout());
    }
    
    const upgradeBtn = this.container.querySelector('#upgrade-account');
    if (upgradeBtn) {
      upgradeBtn.addEventListener('click', () => this.handleUpgrade());
    }
  }
  
  private async handleLogout(): Promise<void> {
    const confirmed = confirm('ログアウトしますか？');
    if (confirmed) {
      try {
        await this.authService.signOut();
        // ページをリロードしてログイン画面に戻る
        window.location.reload();
      } catch (error) {
        console.error('Logout failed:', error);
        alert('ログアウトに失敗しました');
      }
    }
  }
  
  private async handleUpgrade(): Promise<void> {
    const confirmed = confirm('Googleアカウントにアップグレードしますか？\n記録が永続的に保存されるようになります。');
    if (!confirmed) return;
    
    try {
      const upgradedUser = await this.authService.upgradeToGoogle();
      this.user = upgradedUser;
      this.render(); // UIを更新
      alert('アカウントのアップグレードが完了しました！');
    } catch (error: any) {
      console.error('Upgrade failed:', error);
      if (error.code === 'auth/credential-already-in-use') {
        alert('このGoogleアカウントは既に使用されています');
      } else {
        alert('アップグレードに失敗しました');
      }
    }
  }
  
  private formatTime(milliseconds: number | null): string {
    if (milliseconds === null) return '--:--';
    
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  
  public updateUser(user: User): void {
    this.user = user;
    this.render();
  }
  
  public mount(parent: HTMLElement): void {
    parent.appendChild(this.container);
  }
  
  public unmount(): void {
    if (this.container.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }
  }
}